import React from 'react';
import { Box, Drawer, List, ListItem, ListItemButton, ListItemText, useTheme } from '@mui/material';
import { Link, useLocation } from 'react-router-dom';
import './Sidebar.css';
import { useSelector } from 'react-redux';
import { selectUser } from '../api/auth/authSlice';

const Sidebar = ({ openSidebar, toggleSidebar }) => {
  let user = useSelector(selectUser);
  const theme = useTheme();
  const location = useLocation();

  const drawerWidth = 240;

  const isSelected = (path) => {
    return location.pathname.startsWith(path);
  };

  const menuItems = (
    <List>
      {user.role === 'partner' && user.is_embedded && (
        <ListItem disablePadding className={isSelected('/dashboard') ? 'selected' : ''}>
          <ListItemButton component={Link} to="/dashboard">
            <ListItemText primary="Dashboard" />
          </ListItemButton>
        </ListItem>
      )}
      <ListItem disablePadding className={isSelected('/organizations') ? 'selected' : ''}>
        <ListItemButton component={Link} to="/organizations">
          <ListItemText primary="Organizations" />
        </ListItemButton>
      </ListItem>
      {user.role === 'admin' && (
        <ListItem disablePadding className={isSelected('/plans') ? 'selected' : ''}>
          <ListItemButton component={Link} to="/plans">
            <ListItemText primary="Plans" />
          </ListItemButton>
        </ListItem>
      )}

      {!user.is_embedded && (
        <ListItem disablePadding className={isSelected('/subscriptions') ? 'selected' : ''}>
          <ListItemButton component={Link} to="/subscriptions">
            <ListItemText primary="Subscriptions" />
          </ListItemButton>
        </ListItem>
      )}

      {user.role === 'admin' && (
        <ListItem disablePadding className={isSelected('/partners') ? 'selected' : ''}>
          <ListItemButton component={Link} to="/partners">
            <ListItemText primary="Partners" />
          </ListItemButton>
        </ListItem>
      )}
    </List>
  );

  return (
    <>
      <Drawer
        variant="temporary"
        open={openSidebar}
        onClose={toggleSidebar}
        ModalProps={{ keepMounted: true }}
        sx={{
          display: { xs: 'block', sm: 'block', md: 'none' },
          '& .MuiDrawer-paper': { boxSizing: 'border-box', width: drawerWidth },
        }}
      >
        <Box
          sx={{
            marginTop: '6vh',
            // width: drawerWidth,
            backgroundColor: theme.palette.primary.main,
            height: '100%',
            color: theme.palette.common.white,
          }}
        >
          {menuItems}
        </Box>
      </Drawer>
      <Drawer
        variant="permanent"
        sx={{
          display: { xs: 'none', sm: 'none', md: 'block' },
          '& .MuiDrawer-paper': {
            width: drawerWidth,
            boxSizing: 'border-box',
            backgroundColor: theme.palette.primary.main,
            color: theme.palette.common.white,
          },
        }}
        open
      >
        <Box
          sx={{
            marginTop: '8vh',
            backgroundColor: theme.palette.primary.main,
            height: '100%',
            color: theme.palette.common.white,
          }}
        >
          {menuItems}
        </Box>
      </Drawer>
    </>
  );
};

export default Sidebar;
